// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.company[data-v-eb214780] {\n  text-align: center;\n  padding-bottom: 30px;\n}\n.company img[data-v-eb214780] {\n  height: 38px;\n  vertical-align: middle;\n}\n", ""]);
// Exports
module.exports = exports;
